import React, { useState } from "react";
import "./qualification.css";

const education = [
  {
    title:
      "Higher Professional Training in Computer Science: Web Application Development",
    place: "UNIR",
    year: "2022-2024",
  },
  { title: "Digital Marketing Master", place: "UNIR", year: "2020-2021" },
  {
    title: "Hispanic Studies: Spanish Language and Literature",
    place: "Universitat de València",
    year: "2015-2019",
  },
  {
    title: "Music Studies - Clarinet",
    place: "Music School Lluis Milà",
    year: "2008-2014",
  },
];

const work = [
  {
    title: "Junior Software Engineer",
    place: "Deutsche Telekom IT Spain",
    year: "2025 - present",
  },
  { title: "Business Developer I", place: "FDS, a DXC Company", year: "2024" },
  { title: "Software Engineer Junior", place: "Capgemini", year: "2024" },
  { title: "SEO Specialist", place: "SEOCOM", year: "2023-2024" },
  { title: "SEO & Web Developer", place: "Digital Menta", year: "2021-2023" },
  { title: "SEO Writer", place: "SLUPU", year: "2021-2022" },
  {
    title: "Spanish teacher",
    place: "Berufliche Schulen Gelnhausen",
    year: "2019-2020",
  },
];

const Qualification = () => {
  const [toggleState, setToggleState] = useState(2);

  const toggleTab = (index) => {
    setToggleState(index);
  };
  return (
    <section className="qualification section" id="qualification">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">Academic and work experience</span>
      <div className="qualification__container container">
        {/*Tabs*/}
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button  qualification__active qualification__hover button--flex"
                : "qualification__button   button--flex"
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>
            Education
          </div>
          <div
            className={
              toggleState === 2
                ? "qualification__button  qualification__active button--flex"
                : "qualification__button   button--flex"
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase qualification__icon"></i>
            Experience
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            {/* Education */}
            {education.map((edu, index) => (
              <div className="qualification__data" key={index}>
                {/*positioning elements right and left*/}
                {index % 2 === 0 ? (
                  <>
                    <div>
                      <h3 className="qualification__title">{edu.title}</h3>
                      <span className="qualification__subtitle">
                        {edu.place}
                      </span>
                      <div className="qualification__calendar">
                        <i className="uil uil-calendar-alt"></i> {edu.year}
                      </div>
                    </div>
                    <div>
                      <span className="qualification__rounder"></span>
                      <span className="qualification__line"></span>
                    </div>
                  </>
                ) : (
                  <>
                    <div></div>
                    <div>
                      <span className="qualification__rounder"></span>
                      <span className="qualification__line"></span>
                    </div>
                    <div>
                      <h3 className="qualification__title">{edu.title}</h3>
                      <span className="qualification__subtitle">
                        {edu.place}
                      </span>
                      <div className="qualification__calendar">
                        <i className="uil uil-calendar-alt"></i> {edu.year}
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            {/* Work */}
            {work.map((work, index) => (
              <div className="qualification__data" key={index}>
                {index % 2 === 0 ? (
                  <>
                    <div>
                      <h3 className="qualification__title">{work.title}</h3>
                      <span className="qualification__subtitle">
                        {work.place}
                      </span>
                      <div className="qualification__calendar">
                        <i className="uil uil-calendar-alt"></i> {work.year}
                      </div>
                    </div>
                    <div>
                      <span className="qualification__rounder"></span>
                      <span className="qualification__line"></span>
                    </div>
                  </>
                ) : (
                  <>
                    <div></div>
                    <div>
                      <span className="qualification__rounder"></span>
                      <span className="qualification__line"></span>
                    </div>
                    <div>
                      <h3 className="qualification__title">{work.title}</h3>
                      <span className="qualification__subtitle">
                        {work.place}
                      </span>
                      <div className="qualification__calendar">
                        <i className="uil uil-calendar-alt"></i> {work.year}
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
